<div class="reset-org-user-password-dialog__root">
  <h1 mat-dialog-title class="headline">Reset Password</h1>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Temporary password</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          autocomplete="new-password"
          placeholder="Share with the user after resetting"
          formControlName="temporaryPassword"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="hidePassword ? 'Show temporary password' : 'Hide temporary password'"
          (click)="hidePassword = !hidePassword"
        >
          <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (temporaryPassword.invalid && temporaryPassword.touched) {
          <mat-error>{{ getPasswordErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      <div class="temp-password-requirements" aria-label="Password requirements">
        <span class="temp-password-requirements__label">Password requirements:</span>
        <ul class="temp-password-requirements__list">
          @for (item of passwordRequirementItems; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>DISCARD</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">RESET</button>
  </mat-dialog-actions>
</div>
